<template>
  <div>
    <tx-action txType="Unstake" />
    <div class="d-flex justify-center mt-16">
      <div class="deposit-box pa-10">
        <c-tx-steps
          class="mt-6"
          borderType="stake"
          :options="steps"
          :current="currentStep"
          @setStep="s => (currentStep = s)"
        />
        <div v-if="currentStep === 1" class="p-relative" style="height: 80%">
          <c-loading v-if="availableBalanceState.fetching" />
          <select-ecosystem :ecosystem="ecosystem" />
          <div class="d-flex justify-space-between align-start mt-16">
            <div class="flex-1">
              <select-asset
                :ecosystem="ecosystem"
                :selectedAsset="currentProject"
              />
            </div>
          </div>
          <div class="mt-16">
            <div class="text-5 font-weight-medium">Delegation</div>
            <v-select
              :items="delegations"
              v-model="form.stakedSuiId"
              item-value="stakedSuiId"
              class="c-input search-stake mt-1"
              placeholder="Select delegation to unstake"
              outlined
              hide-details
            >
              <template v-slot:item="{ item }">
                <div class="flex-1 d-flex align-center justify-space-between">
                  <div class="text-4">
                    {{ item.stakedSuiId | addressFormat }}
                  </div>
                  <div class="text-5  gray--text">
                    <span class="darkgray--text">{{
                      item.validator.name
                    }}</span>
                    <span class="ml-2 mr-2">|</span>
                    <span>
                      {{ item.balance | denomFormat }}
                    </span>
                    <span class="ml-1">
                      {{ currentProject.staking.token | uppercase }}
                    </span>
                  </div>
                </div>
              </template>
              <template v-slot:selection="{ item }">
                <div
                  class="flex-1 d-flex align-center justify-space-between selection-item"
                >
                  <div class="text-4">
                    {{ item.stakedSuiId | addressFormat }}
                  </div>
                  <div class="text-5 gray--text">
                    <span class="darkgray--text">{{
                      item.validator.name
                    }}</span>
                    <span class="ml-2 mr-2">|</span>
                    <span>
                      {{ item.balance | denomFormat }}
                    </span>
                    <span class="ml-1">
                      {{ currentProject.staking.token | uppercase }}
                    </span>
                  </div>
                </div>
              </template>
            </v-select>
          </div>
          <div class="mt-16">
            <c-btn
              class="width-100"
              @click="next"
              :disabled="btnNextDisabled"
              walletRequired
              >Continue</c-btn
            >
          </div>
        </div>
        <confirm
          v-if="currentStep === 2"
          class="mt-16"
          :delegation="selectedDelegation"
          @close="$emit('close')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import TxAction from "@/views/stake/components/tx/TxAction.vue";
import Confirm from "./Confirm.vue";
import SelectEcosystem from "@/views/stake/components/tx/SelectEcosystem.vue";
import SelectAsset from "@/views/stake/components/tx/SelectAsset.vue";

export default {
  components: {
    TxAction,
    Confirm,
    SelectEcosystem,
    SelectAsset,
  },
  computed: {
    ...mapGetters({
      availableBalanceState: "staking/sui/availableBalance",
      walletSelected: "userWallets/walletSelected",
      currentProject: "projectConfig/latestProject",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      delegationsState: "staking/sui/delegations",
    }),
    delegations() {
      return (
        this.delegationsState.result?.filter(item => item.unstakeable) || []
      );
    },
    availableBalance() {
      return Number(this.availableBalanceState.result?.balance) || 0;
    },
    isSufficentAmount() {
      return new BN(this.availableBalance).isGreaterThan(0);
    },
    btnNextDisabled() {
      if (!this.currentProject.status?.active) return true;
      return !this.isSufficentAmount || !this.form.stakedSuiId;
    },
    selectedDelegation() {
      return this.delegations.find(
        item => item.stakedSuiId === this.form.stakedSuiId
      );
    },
  },
  filters: {
    addressFormat(value) {
      return value.slice(0, 6) + "..." + value.slice(-6);
    },
  },
  data: () => ({
    ecosystem: "Sui",
    steps: [
      {
        step: 1,
        text: "Select delegation",
      },
      {
        step: 2,
        text: "Confirm",
      },
    ],
    currentStep: 1,
    form: {
      stakedSuiId: 0,
    },
  }),
  methods: {
    next() {
      this.currentStep = 2;
    },
  },
  watch: {
    ["walletSelected.address"]() {
      this.currentStep = 1;
      this.form.stakedSuiId = 0;
    },
  },
};
</script>
